import { connect } from 'react-redux';
import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { untouch, change as changeFieldValue } from 'redux-form';

import { UPDATE_APPOINTMENT_FORM } from 'modules/appointmentsManagement/constants/formTypes';
import {
  getUserGenderOptions,
  getUserTitleOptions,
} from 'modules/appointmentsManagement/selectors/appointments';
import {
  getCustomerAppointmentUserReadPermissions,
  getCustomerAppointmentUserUpdatePermissions,
  // getSubjectAppointmentUserReadPermissions,
  // getSubjectAppointmentUserUpdatePermissions,
} from 'modules/appointmentsManagement/selectors/users';
import { getCommonUserConfig } from 'modules/user/selectors/users';

import PatientDetailsForm from './PatientDetailsForm';

const mapStateToProps = (state, { intl, fieldName }) => {
  const userCustomerReadPermissions = getCustomerAppointmentUserReadPermissions(state);
  const userCustomerUpdatePermissions = getCustomerAppointmentUserUpdatePermissions(state);
  const userSubjectReadPermissions = undefined; // getSubjectAppointmentUserReadPermissions(state);
  const userSubjectUpdatePermissions = undefined; // getSubjectAppointmentUserUpdatePermissions(state);

  return {
    form: UPDATE_APPOINTMENT_FORM,
    userGenderOptions: getUserGenderOptions(intl),
    userTitleOptions: getUserTitleOptions(intl),
    userReadPermissions: fieldName === 'customer' ? userCustomerReadPermissions : userSubjectReadPermissions,
    userUpdatePermissions: fieldName === 'customer' ? userCustomerUpdatePermissions : userSubjectUpdatePermissions,
    userFieldConfig: getCommonUserConfig(state),
  };
};

export default compose(
  injectIntl,
  connect(mapStateToProps, { untouch, changeFieldValue }),
)(PatientDetailsForm);
